import {useQuery} from '@tanstack/react-query';
import {
    getOperatorActiveChats,
    getOperatorAverageRating,
    getOperatorAverageWaitTime,
    getOperatorOpenChats,
    getOperatorResolvedChats,
    getOperatorUnreadChats,
} from './operator-dashboard-home-api';

/* -----------------------------
 * 1) Open Chats
 * ----------------------------- */
export const useOperatorOpenChats = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['operator-dashboard', 'open-chats', startDate || null],
        queryFn: () => getOperatorOpenChats(startDate),
        ...options,
    });
};

/* -----------------------------
 * 2) Average Rating
 * ----------------------------- */
export const useOperatorAverageRating = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['operator-dashboard', 'average-rating', startDate || null],
        queryFn: () => getOperatorAverageRating(startDate),
        ...options,
    });
};

/* -----------------------------
 * 3) Average Wait Time
 * ----------------------------- */
export const useOperatorAverageWaitTime = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['operator-dashboard', 'average-wait-time', startDate || null],
        queryFn: () => getOperatorAverageWaitTime(startDate),
        ...options,
    });
};

/* -----------------------------
 * 4) Unread Chats (no startDate)
 * ----------------------------- */
export const useOperatorUnreadChats = (options = {}) => {
    return useQuery({
        queryKey: ['operator-dashboard', 'unread-chats'],
        queryFn: getOperatorUnreadChats,
        ...options,
    });
};

/* -----------------------------
 * 5) Active Chats (no startDate)
 * ----------------------------- */
export const useOperatorActiveChats = (options = {}) => {
    return useQuery({
        queryKey: ['operator-dashboard', 'active-chats'],
        queryFn: getOperatorActiveChats,
        ...options,
    });
};

/* --------------------------
 * 6) useResolvedChats
 * -------------------------- */
export const useOperatorResolvedChats = (startDate, options = {}) => {
    return useQuery({
        queryKey: ['operator-dashboard', 'resolved-chats'],
        queryFn: () => getOperatorResolvedChats(startDate),
        ...options,
    });
};